// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__2DLaR","container":"table_container__1UTNG","stripedA":"table_stripedA__1tnE6","stripedB":"table_stripedB__3qZYj"};